// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ab524","sectionTitle":"style_sectionTitle__NvUeM"};